import * as p from './plugins';

export { Plugin, respond, listen, help, permissionGroup } from './plugin';
export const plugins = p;



// WEBPACK FOOTER //
// ./plugins/index.js